module.exports = __webpack_public_path__ + "img/Phone_Black@2x.0747ca88.png";